exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fileicon{padding:5px;height:90px;width:90px}.roeditr{min-height:150px;padding:12px 8px 16px;line-height:1.33;font-family:inherit;color:inherit;overflow-y:auto;border:1px solid #ced4da;border-radius:.25rem;width:100%;max-height:700px}.toolbar{padding:0 0 10px;display:flex;justify-content:flex-end}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c1756070","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/MailItem.vue
// module id = 651
// module chunks = 0